import { render, staticRenderFns } from "./table-column-drag-item.vue?vue&type=template&id=a8d921b4&scoped=true"
import script from "./table-column-drag-item.vue?vue&type=script&lang=js"
export * from "./table-column-drag-item.vue?vue&type=script&lang=js"
import style0 from "./table-column-drag-item.vue?vue&type=style&index=0&id=a8d921b4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d921b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8d921b4')) {
      api.createRecord('a8d921b4', component.options)
    } else {
      api.reload('a8d921b4', component.options)
    }
    module.hot.accept("./table-column-drag-item.vue?vue&type=template&id=a8d921b4&scoped=true", function () {
      api.rerender('a8d921b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-public/com-yd-table/components/table-bar/components/table-column-drag-item.vue"
export default component.exports